import { CLOVER, SHOPIFY, SQUARE } from "@faire/retailer-visitor-shared/features/PointOfSale/consts";
// Only used as reference, but the enum value maps to the corresponding IPOSItem field (when applicable)
export var ColumnKey;
(function(ColumnKey) {
    ColumnKey["CHECKBOX"] = "checkbox";
    ColumnKey["IMAGE"] = "images";
    ColumnKey["TITLE"] = "name";
    ColumnKey["DESCRIPTION"] = "description";
    ColumnKey["BRAND"] = "brandName";
    ColumnKey["STATUS"] = "shopifyStatus";
    ColumnKey["PRODUCT_ORGANIZATION"] = "product_organization";
    ColumnKey["PRODUCT_TYPE"] = "category";
    ColumnKey["COLLECTIONS"] = "collections";
    ColumnKey["TAGS"] = "tags";
    ColumnKey["PRICING"] = "pricing";
    ColumnKey["COST_PER_ITEM"] = "wholesalePrice";
    ColumnKey["RETAIL_PRICE"] = "retailPrice";
    ColumnKey["SALES_TAXES"] = "salesTaxes";
    ColumnKey["TAXABLE"] = "taxable";
    ColumnKey["TAXES"] = "taxes";
    ColumnKey["SKU"] = "sku";
    ColumnKey["BARCODE"] = "upc";
    ColumnKey["SHIPPING"] = "shipping";
    ColumnKey["SHIPPING_REQUIRED"] = "requiresShipping";
    ColumnKey["SHIPPING_WEIGHT"] = "weight";
    ColumnKey["PRINTER_LABEL"] = "printerLabels";
    ColumnKey["REVENUE_CLASS"] = "revenueClasses";
    ColumnKey["CATEGORIES"] = "categories";
    ColumnKey["CATEGORIZATION"] = "categorization";
    ColumnKey["REPORTING_CATEGORY"] = "reportingCategory";
})(ColumnKey || (ColumnKey = {}));
export var getEditorColumns = function(type) {
    switch(type){
        case SQUARE:
            return [
                {
                    key: ColumnKey.CHECKBOX
                },
                {
                    key: ColumnKey.IMAGE
                },
                {
                    key: ColumnKey.TITLE
                },
                {
                    key: ColumnKey.DESCRIPTION
                },
                {
                    key: ColumnKey.CATEGORIZATION,
                    groupedSubColumns: true,
                    subColumns: [
                        {
                            key: ColumnKey.CATEGORIES
                        },
                        {
                            key: ColumnKey.REPORTING_CATEGORY
                        }
                    ]
                },
                {
                    key: ColumnKey.COST_PER_ITEM
                },
                {
                    key: ColumnKey.RETAIL_PRICE
                },
                {
                    key: ColumnKey.SALES_TAXES,
                    groupedSubColumns: true,
                    subColumns: [
                        {
                            key: ColumnKey.TAXABLE
                        },
                        {
                            key: ColumnKey.TAXES
                        }
                    ]
                },
                {
                    key: ColumnKey.SKU
                },
                {
                    key: ColumnKey.BARCODE
                }
            ];
        case CLOVER:
            return [
                {
                    key: ColumnKey.CHECKBOX
                },
                {
                    key: ColumnKey.IMAGE
                },
                {
                    key: ColumnKey.TITLE
                },
                {
                    key: ColumnKey.CATEGORIES
                },
                {
                    key: ColumnKey.COST_PER_ITEM
                },
                {
                    key: ColumnKey.RETAIL_PRICE
                },
                {
                    key: ColumnKey.TAXES
                },
                {
                    key: ColumnKey.REVENUE_CLASS
                },
                {
                    key: ColumnKey.SKU
                },
                {
                    key: ColumnKey.BARCODE
                },
                {
                    key: ColumnKey.PRINTER_LABEL
                }
            ];
        case SHOPIFY:
            return [
                {
                    key: ColumnKey.CHECKBOX
                },
                {
                    key: ColumnKey.IMAGE
                },
                {
                    key: ColumnKey.TITLE
                },
                {
                    key: ColumnKey.DESCRIPTION
                },
                {
                    key: ColumnKey.BRAND
                },
                {
                    key: ColumnKey.STATUS
                },
                {
                    key: ColumnKey.PRODUCT_ORGANIZATION,
                    subColumns: [
                        {
                            key: ColumnKey.PRODUCT_TYPE
                        },
                        {
                            key: ColumnKey.COLLECTIONS
                        },
                        {
                            key: ColumnKey.TAGS
                        }
                    ]
                },
                {
                    key: ColumnKey.PRICING,
                    subColumns: [
                        {
                            key: ColumnKey.COST_PER_ITEM
                        },
                        {
                            key: ColumnKey.RETAIL_PRICE
                        },
                        {
                            key: ColumnKey.TAXABLE
                        }
                    ]
                },
                {
                    key: ColumnKey.SKU
                },
                {
                    key: ColumnKey.BARCODE
                },
                {
                    key: ColumnKey.SHIPPING,
                    groupedSubColumns: true,
                    subColumns: [
                        {
                            key: ColumnKey.SHIPPING_REQUIRED
                        },
                        {
                            key: ColumnKey.SHIPPING_WEIGHT
                        }
                    ]
                }
            ];
        default:
            return [];
    }
};
export var AlwaysVisibleColumns = [
    ColumnKey.CHECKBOX,
    ColumnKey.IMAGE,
    ColumnKey.TITLE
];
